import React from 'react';

const Footer = () => {
    const copyrightYear = new Date().getFullYear(); //TODO: expose copyright year in react-app

    return <footer className="footer" id="footer-section">
        <div className="container">
            <span className="copyright">Copyright &copy; {copyrightYear}. | #BecomingBolts | Cori &amp; Rocko</span>
        </div>
    </footer>;
};

export default Footer;
